import React, { useEffect, useContext, useState, useMemo } from 'react'
import { Layout } from 'antd'
import { withRouter } from 'react-router'
import classnames from 'classnames'
import i18n from 'i18next'
import Routes from './routes'
import { AuthContextProvider } from 'contexts/AuthContext'
import { TimeContextProvider } from 'contexts/TimeContext'
import { WorkoutContextProvider } from 'contexts/WorkoutContext'
import { InitContextProvider } from 'contexts/InitContext'
import { getPartnerId, getToken } from 'utils/authLocalStorage'
import {
  ResourceContext,
  ResourceContextProvider,
} from 'contexts/ResourceContext'
import {
  getAppFirstOpen,
  getCurrentLanguage,
  setCurrentLanguage,
} from 'utils/wwLocalStorage'
import { styles } from './App.module.scss'
import { useAutoLogin } from 'hooks/useAutoLogin'
import { isPremiumUser, PARTNER_ID } from 'utils/basic'
import { InterstitialModal } from 'components/InterstitialModal/index'
import { useReviveOnboardingCheck } from 'hooks/useReviveOnboardingCheck'
import { BrowseContextProvider } from 'contexts/BrowseContext'
const { Content } = Layout

const App = (props) => {
  const rContext = useContext(ResourceContext)
  const [darkMode, setDarkMode] = useState(false)
  const [interstitialModal, setInterstitialModal] = useState()
  const [initialUrl] = useState(props.location.pathname)

  const isRevive = useMemo(() => {
    return props.location.pathname?.includes('/revive')
  }, [props.location.pathname])

  useEffect(() => {
    const formatPathName = props.location.pathname.split('/')[1].toLowerCase()
    if (['mobile', 'partner'].includes(formatPathName)) {
      const savedLanguage = getCurrentLanguage()
      const token = getToken()
      if (savedLanguage !== i18n.language && token) {
        rContext.forceUpdateResource()
        setCurrentLanguage(i18n.language)
      } else {
        if (token) rContext.initResource()
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const { autoLoginLoading, planId } = useAutoLogin()

  useEffect(() => {
    if (!autoLoginLoading) {
      const isDarkMode = +getPartnerId() === PARTNER_ID.NOOM_VIBE
      setDarkMode(isDarkMode)
      const token = getToken()
      const pathName = props.location.pathname
      if (token && pathName !== '/partner/error' && !isDarkMode && !isRevive) {
        setInterstitialModal(getAppFirstOpen())
      }
    }
  }, [autoLoginLoading, props.location.pathname, isRevive])

  useEffect(() => {
    if (autoLoginLoading && planId) {
      const pathName = props.location.pathname
      if (pathName === '/partner/browse/plan') {
        if (isPremiumUser()) {
          props.history.replace(`/partner/browse/plan/${planId}`)
        } else {
          props.history.replace(`/partner/browse/${props.location.search}`)
        }
      }
    }
  }, [
    planId,
    autoLoginLoading,
    props.location.pathname,
    props.history,
    props.location.search,
  ])

  useReviveOnboardingCheck({
    isRevive,
    autoLoginLoading,
    history: props.history,
    initialUrl,
  })

  return (
    <Layout className={classnames(styles, darkMode ? 'dark-mode' : '')}>
      <Content className={classnames('main')}>
        <Routes {...{ autoLoginLoading, darkMode, planId, isRevive }} />
        <InterstitialModal
          {...{
            visible: interstitialModal,
            setVisible: setInterstitialModal,
          }}
        />
      </Content>
    </Layout>
  )
}

export default withRouter(
  AuthContextProvider(
    InitContextProvider(
      TimeContextProvider(
        ResourceContextProvider(
          WorkoutContextProvider(BrowseContextProvider(App))
        )
      )
    )
  )
)
